// extracted by mini-css-extract-plugin
module.exports = {"products_eu":"EUFlashSale2_products_eu___6ru4"};